<template>
  <v-data-table
    :headers="headers"
    :items="items"
    hide-default-footer
    :items-per-page="20"
    class="ordera-box-shadow striped-table"
  >
    <template v-slot:item.pivot.quantity="props">
      <v-edit-dialog :return-value.sync="props.item.pivot.quantity">
        {{ props.item.pivot.quantity }}
        <template v-slot:input>
          <text-field v-model="props.item.pivot.quantity" :label="$t('change')" counter />
        </template>
      </v-edit-dialog>
    </template>
    <template v-slot:item.actions="{ item }">
      <remove-button @click="$emit('removeGrocery', item)"></remove-button>
    </template>
  </v-data-table>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  computed: {
    headers() {
      return [
        {
          text: "Id",
          align: "start",
          sortable: true,
          value: "id",
        },
        {
          text: this.$t("title"),
          align: "start",
          sortable: true,
          value: "name",
        },
        {
          text: this.$t("quantity"),
          value: "pivot.quantity",
          align: "end",
          sortable: true,
        },
        {
          text: this.$t("q"),
          value: "measure",
          align: "start",
          sortable: false,
        },
        {
          text: this.$t("opt"),
          value: "actions",
          align: "end",
          sortable: false,
        },
      ];
    },
  },
};
</script>
